import { useMemo } from 'react';
import type { ReactNode } from 'react';
import { AuthContext, type AuthContextValue } from './auth-context';
import { authClient, type AuthSession } from '../lib/auth-client';

export function AuthProvider({ children }: { children: ReactNode }) {
  const sessionResult = authClient.useSession();
  const session = (sessionResult.data as AuthSession | null) ?? null;
  const loading = sessionResult.isPending;

  const value = useMemo<AuthContextValue>(
    () => ({
      loading,
      session,
      user: session?.user ?? null,
      signOut: async () => {
        const result = await authClient.signOut({});
        if (result.error) throw new Error(result.error.message);
      },
    }),
    [loading, session],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
